var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { docReady } from '../utils/docReady';
const typeNames = {
    'product': 'Products',
    'page': 'Pages',
    'article': 'Journal Articles',
    'collection': 'Collections',
    'treatments': 'Treatments'
};
class LiveSearch {
    constructor(container) {
        this.shouldRedirect = undefined;
        this.resultsCount = 0;
        this.resultsLimit = 5;
        this.isEmpty = false;
        this.hasClosed = false;
        this.searchContainer = container;
        this.searchInput = this.searchContainer.querySelector('.live-search-field');
        this.searchButton = this.searchContainer.querySelector('.live-search-button');
        this.liveSearch = this.searchContainer.querySelector('.live-search-live');
        this.seeAllButton = this.searchContainer.querySelector('.live-search-live-button');
        this.liveSearchInputContainer = this.searchContainer.querySelector('.live-search-container');
        this.liveSearchContainer = this.searchContainer.querySelector('.live-search-live-container');
        this.liveSearchResults = this.searchContainer.querySelector('.live-search-live-results');
        this.liveSearchCount = this.searchContainer.querySelector('.live-search-live-results__count');
        this.liveSearchTotal = this.searchContainer.querySelector('.live-search-live-results__total');
        this.searchOpen = document.querySelector('#header-search');
        this.searchOpenSecondary = document.querySelector('#header-search-secondary');
        this.searchClose = document.querySelector('.live-search-close');
        this.overlay = document.querySelector('.live-search-overlay');
        this.body = document.querySelector('body');
        this.liveSearch.style.setProperty('--search-height', `${this.liveSearchInputContainer.offsetHeight}px`);
        this.resultsLimit = parseInt(this.liveSearch.dataset.resultsLimit);
        this.initEventListeners();
        let currValue = this.searchInput.value;
        if (currValue.length > 0) {
            setTimeout(() => {
                this.getResults(currValue);
            }, 1000);
        }
    }
    getResults(searchTerm) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                let response = yield fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product,article,collection&resources[limit]=${this.resultsLimit}`);
                let responsePages = yield fetch(`/search?q=${searchTerm}&view=json`);
                let data = yield response.json();
                let dataPages = yield responsePages.json();
                let results = (data.resources || {}).results;
                (results || {}).pages = [];
                (results || {}).treatments = [];
                (results || {}).rituals = [];
                (results || {}).products = [];
                let newCollections = [];
                let collectionMetafieldQuery = results.collections.map((collection) => {
                    return `id:${collection.id}`;
                }).join(' OR ');
                let collectionMetafieldResponse = yield fetch(`https://rationale-uk-prod.myshopify.com/api/2023-07/graphql.json`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': 'a17320769c88a977ebee585a3590ae2d'
                    },
                    body: JSON.stringify({
                        query: `
                        query {
                            collections(first: ${results.collections.length}, query: "${collectionMetafieldQuery}") {
                                edges {
                                    node {
                                        id
                                        hide: metafield(namespace: "custom", key: "hide_from_search") {
                                            value
                                        }
                                        treatment: metafield(namespace: "custom", key: "is_treatment") {
                                            value
                                        }
                                        edit: metafield(namespace: "custom", key: "is_ritual") {
                                            value
                                        }
                                    }
                                }
                            }
                        }
                    `
                    })
                });
                let collectionMetafieldData = yield collectionMetafieldResponse.json();
                let collectionMetafields = {};
                collectionMetafieldData.data.collections.edges.map((edge) => {
                    collectionMetafields[edge.node.id.replace('gid://shopify/Collection/', '')] = edge.node;
                });
                (dataPages.results || []).map((result) => {
                    if (result.isTreatment == 'true') {
                        results.treatments.push(result);
                    }
                    else if (result.isRitual == 'true') {
                        results.rituals.push(result);
                    }
                    else if (result.type == 'page') {
                        results.pages.push(result);
                    }
                    else if (result.type == 'product') {
                        results.products.push(result);
                    }
                });
                (results || {}).collections.map((collection) => {
                    let collectionMetafield = collectionMetafields[collection.id];
                    if (collectionMetafield.hide && collectionMetafield.hide.value == 'true')
                        return;
                    if (collectionMetafield.edit && collectionMetafield.edit.value == 'true') {
                        results.rituals.push(collection);
                    }
                    else if (collectionMetafield.treatment && collectionMetafield.treatment.value == 'true') {
                        results.treatments.push(collection);
                    }
                    else {
                        newCollections.push(collection);
                    }
                });
                (results || {}).collections = newCollections;
                if (!results)
                    return resolve(false);
                let total = Object.keys(results).reduce((acc, key) => acc + results[key].length, 0);
                this.liveSearchContainer.innerHTML = '';
                this.resultsCount = total;
                if (total == 0)
                    return resolve(false);
                ['collections', 'pages', 'treatments', 'rituals', 'edits', 'articles', 'products'].map((type) => {
                    let searchResults = results[type];
                    if (!searchResults || searchResults.length == 0)
                        return;
                    let normalResults = document.querySelector('.live-search-live__result-normal');
                    let productGrid = null;
                    let currentEl = normalResults;
                    if (type == 'products') {
                        productGrid = document.createElement('div');
                        productGrid.classList.add('live-search-live__result-grid');
                        this.liveSearchContainer.appendChild(productGrid);
                        currentEl = productGrid;
                    }
                    else {
                        if (!normalResults) {
                            normalResults = document.createElement('div');
                            normalResults.classList.add('live-search-live__result-normal');
                            currentEl = normalResults;
                            this.liveSearchContainer.appendChild(normalResults);
                        }
                        let typeSection = document.createElement('div');
                        typeSection.classList.add('live-search-live__result-type-section');
                        normalResults.appendChild(typeSection);
                        currentEl = typeSection;
                    }
                    let typeEl = document.createElement('div');
                    typeEl.classList.add('live-search-live__result-type');
                    typeEl.innerHTML = type == 'rituals' ? 'Edits' : type;
                    currentEl.appendChild(typeEl);
                    searchResults.map((result, i) => {
                        if (i > 5)
                            return;
                        let searchResultEl = document.createElement('a');
                        searchResultEl.classList.add('live-search-live__result');
                        searchResultEl.setAttribute('href', result.url);
                        if (type == 'products') {
                            searchResultEl.classList.add('live-search-live__result__product');
                            searchResultEl.innerHTML = `
                      <div class="live-search-live__result-image live-search-live__result__product-image">
                        <img src="${result.featuredImage}" alt="${result.title}">
                      </div>
                      <div class="live-search-live__result-text live-search-live__result__product-text">
                        <h4 class="live-search-live__result__title live-search-live__result__product-title">${result.title}</h4>
                        ${result.byline ? `<p class="live-search-live__result__byline">${result.byline}</p>` : ''}
                        <div class="live-search-live__result__price live-search-live__result__product-price">${result.price}</div>
                      </div>
                  `;
                        }
                        else {
                            searchResultEl.innerHTML = `
                      <div class="live-search-live__result-text">
                        <div class="live-search-live__result__title">${result.title}</div>
                      </div>
                  `;
                        }
                        if (type == 'products') {
                            productGrid.appendChild(searchResultEl);
                        }
                        else {
                            currentEl.appendChild(searchResultEl);
                        }
                    });
                });
                resolve(this.resultsCount > 0);
            }));
        });
    }
    updateLiveSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            let currValue = this.searchInput.value;
            let resultsFound = yield this.getResults(currValue);
            if (currValue.length > 0 && resultsFound) {
                this.liveSearch.classList.add('live-search-live--active');
                this.body.classList.add('locked');
            }
            else {
                this.liveSearch.classList.remove('live-search-live--active');
                this.body.classList.remove('locked');
            }
        });
    }
    ;
    initEventListeners() {
        this.searchOpen.addEventListener('click', (event) => {
            this.searchContainer.classList.add('live-search--active');
            this.searchInput.focus();
        });
        this.searchOpenSecondary.addEventListener('click', (event) => {
            this.searchContainer.classList.add('live-search--active');
            this.searchInput.focus();
        });
        this.searchClose.addEventListener('click', (event) => {
            this.searchInput.value = '';
            this.updateLiveSearch();
            this.searchContainer.classList.remove('live-search--active');
            this.hasClosed = true;
            document.querySelector('.header__bag-icon').style.pointerEvents = 'none';
            setTimeout(() => {
                document.querySelector('.header__bag-icon').style.pointerEvents = 'all';
            }, 500);
        });
        this.overlay.addEventListener('click', (event) => {
            this.searchInput.value = '';
            this.updateLiveSearch();
            this.searchContainer.classList.remove('live-search--active');
            this.hasClosed = true;
            document.querySelector('.header__bag-icon').style.pointerEvents = 'none';
            setTimeout(() => {
                document.querySelector('.header__bag-icon').style.pointerEvents = 'all';
            }, 500);
        });
        this.searchInput.addEventListener('keyup', (event) => {
            let currValue = this.searchInput.value;
            this.isEmpty = currValue.length == 0;
            let redirectFound = window.searchRedirects.find((redirect) => {
                return redirect.searchTerm.toLowerCase() === currValue.toLowerCase();
            });
            if (redirectFound) {
                this.shouldRedirect = redirectFound.redirectTarget;
            }
            else {
                this.shouldRedirect = undefined;
            }
            if (this.searchTimeout)
                clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.updateLiveSearch();
            }, 100);
        });
        this.searchButton.addEventListener('click', this.goToResults.bind(this));
        this.seeAllButton.addEventListener('mousedown', this.goToResults.bind(this));
    }
    goToResults() {
        if (this.shouldRedirect) {
            window.location.href = this.shouldRedirect;
        }
        else {
            window.location.href = '/search/?q=' + this.searchInput.value;
        }
    }
}
docReady(() => {
    const searchContainer = document.querySelector('.live-search');
    if (!searchContainer)
        return;
    const liveSearch = new LiveSearch(searchContainer);
});
